﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailBenutzer extends GuiDetailGeneric {
    constructor() {
        super("Benutzer");
    }

    attachEvents(): void {
        super.attachEvents();
        $("#btnSendNewPassword").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickSendAktivierung(e));
        $("#btnUnlockUser").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickUnlockUser(e));
        $("#btnObfuscateUser").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickObfuscateUser(e));
        $("#btnCopyLink").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickCopyLink(e));
        $("#btnReset2FA").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButtonConfirm(e));

        $("#btnAzureInvite").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButtonConfirm(e));
        $("#btnAzureRemove").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButtonConfirm(e));

        $("#btnAnfallstelleAdd").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickAnfallstelleAdd(e));

        // EanvSignatur
        $("#btnEanvRemove").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButtonConfirm(e));
        $("#btnEanvCreate").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButtonConfirm(e));

    }

    clickAnfallstelleAdd(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickAnfallstelleAdd");
        this.doAction(e);
    }

    private clickSendAktivierung(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickSendAktivierung");
        this.clickActionButtonConfirm(e);
    }

    private clickUnlockUser(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickUnlockUser");
        this.clickActionButtonConfirm(e);
    }

    private clickObfuscateUser(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickObfuscateUser");
        this.clickActionButtonConfirm(e);
    }

    private clickCopyLink(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickCopyLink");
        e.preventDefault();
        const link = $("#VmDetail_AktivierungsLink").val() as string;
        this.copyTextToClipboard(link);
    }


    private copyTextToClipboard(text: string) {
        this.log("copyTextToClipboard");

        if (navigator && navigator.clipboard && navigator.clipboard.writeText)
            return navigator.clipboard.writeText(text);
        return Promise.reject('The Clipboard API is not available.');

        ////const copyFrom = $("<textarea/>");
        ////copyFrom.text(text);
        ////$("body").append(copyFrom);
        //$("#VmDetail_AktivierungsLink").select();
        //let copyText = document.querySelector("#VmDetail_AktivierungsLink");
        //copyText.select();

        //var value = $("#VmDetail_AktivierungsLink").val() as string;
        //navigator.clipboard.writeText(value);
        //new ClipboardJS()
        ////document.execCommand("copy");
        ////copyFrom.remove();
    }
}
